import { useAtomValue } from 'jotai';
import { localizationDataAtom } from '../../atoms';

export const useLocalizationData = () => {
    const localizationData = useAtomValue(localizationDataAtom);
    return localizationData;
};
